import { createStore } from '../_core/createStore';
import { lazyDependency } from '../_core/lazyDependency';
import useApiStore from '../apiStore/useApiStore';
import { brandingStore } from './brandingStore';

const useBrandingStore = createStore({
  creator: brandingStore({
    useApiStore: lazyDependency(() => useApiStore),
  }),
  id: 'branding',
  middlewares: {
    devtools: true,
  },
});

export default useBrandingStore;
